import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyTigerMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#f1c27d" />
      {/* stripes */}
      {Array.from({ length: 10 }).map((_, i) => (
        <rect key={i} x={80 + i * 60} y={120} width={20} height={883} fill="#5a2d0c" opacity={0.9} />
      ))}
      <g className="mode-copy" transform="translate(48,840)" fill="#2b170b">
        <text x={0} y={0} fontSize={18} fontWeight={700}>{Copy?.title}</text>
      </g>
    </g>
  );
}

export default VasarelyTigerMode;
